import { ReactNode, useMemo } from 'react';

// third-party
import { IntlProvider } from 'react-intl';

// project import
import useConfig from 'hooks/useConfig';
import { flattenMessages } from 'utils/flattenMessages';

// static imports — no dynamic import caching issues
import thMessages from 'utils/locales/th.json';
import enMessages from 'utils/locales/en.json';

// pre-flatten at module level (runs once)
const localeMap: Record<string, Record<string, string>> = {
  th: flattenMessages(thMessages as Record<string, unknown>),
  en: flattenMessages(enMessages as Record<string, unknown>)
};

// ==============================|| LOCALIZATION ||============================== //

interface Props {
  children: ReactNode;
}

const Locales = ({ children }: Props) => {
  const { i18n } = useConfig();

  const messages = useMemo(() => localeMap[i18n] || localeMap.en, [i18n]);

  return (
    <IntlProvider locale={i18n} defaultLocale="en" messages={messages}>
      {children}
    </IntlProvider>
  );
};

export default Locales;
